<template>
  <div>
    <!-- отключаем multi-sort если включен group-by (работает нестабильно из за server-items-length) -->
    <v-data-table
        :headers="settingsKey===undefined ? localHeaders : visibleHeaders"
        :items="items"
        :server-items-length="count"
        :loading="loading"
        :options.sync="options"
        :footer-props="{'items-per-page-options': $tools.isDefined(disablePagination) ? [1000] : [100, 500, 1000, 5000]}"
        :items-per-page="$tools.isDefined(disablePagination) ? 1000 : 100"
        dense
        :height="height-(16*6)"
        :fixed-header="typeof height!=='undefined'"
        :multi-sort="!groupBy"
        :show-select="selectAll!==undefined"
        :class="(typeof tableClass==='undefined' ? '' : ' '+tableClass)"
        :sort-by="typeof sortBy !=='undefined' ? sortBy : null"
        ref="nTable"
        :group-by="typeof groupBy!==undefined ? groupBy : false"
        :hide-default-footer="$tools.isDefined(disablePagination)"
        item-key="_key"
    >
      <template v-slot:group.header="{items, isOpen, toggle}">
        <th :colspan="headers.length+(selectAll!==undefined&&1)" @click="toggle">
          <div class="d-flex align-center">
            <v-icon dense small
            >{{ isOpen ? 'mdi-folder-open-outline' : 'mdi-folder-outline' }}
            </v-icon>
            <span class="text-subtitle-1 pl-3 font-weight-medium">
                {{ groupBy.split('.').reduce((acc, part) => acc && acc[part], items[0]) }}
              </span>
          </div>
        </th>
      </template>
      <template v-slot:header.data-table-select="">
        <v-checkbox
            v-if="selectAll!==undefined"
            :input-value="selectAll"
            @change="$emit('update:selectAll', !selectAll)"
            :indeterminate="selectIndeterminate"
            class="ma-0 pa-0" dense hide-details/>
      </template>
      <template v-slot:top="{ pagination, options, updateOptions }">
        <v-row no-gutters class="d-none d-lg-flex">
          <v-col>
            <v-toolbar dense elevation="0" color="transparent" max-height="48px">
              <v-toolbar-title v-if="typeof name!=='undefined'" class="body-2 font-weight-medium">{{
                  name
                }}
              </v-toolbar-title>
              <v-spacer/>
              <div>
                <slot name="barActions"/>

                <template v-if="settingsKey!==undefined">
                  <tooltip right>
                    <v-btn
                        color="grey"
                        class="px-2"
                        text
                        @click="tableSettingsOpen=true"
                    >
                      <v-icon small>mdi-cog-outline</v-icon>
                    </v-btn>
                    <template v-slot:content>
                      Настройки
                    </template>
                  </tooltip>

                  <dialog-editor :item.sync="tableSettingsOpen" name="Настройки таблицы" width="800"
                                 submitText="Сохранить" @submit="saveTableSettings();tableSettingsOpen=null"
                                 content-padding-remove>
                    <template v-slot:footerActions>
                      <v-btn
                          @click="localHeaders = localHeadersDefault"
                          color="primary" text
                      >
                        Сбросить настройки
                      </v-btn>
                    </template>
                    <v-simple-table class="pa-0" dense>
                      <template v-slot:default>
                        <thead>
                        <tr>
                          <th>Название</th>
                          <th>Показать</th>
                          <th>Сортировка</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="(item, index) in headers"
                            :key="'setting'+index"
                            :style="settingsKey!==undefined&&item.isSelected&&{background:'#E8F5E9'}"
                        >
                          <td class="py-1">
                            {{ item.text }}
                          </td>
                          <td class="py-1">
                            <v-checkbox
                                v-model="item.visible"
                                color="primary"
                                hide-details
                                class="pa-0 mt-0"
                            ></v-checkbox>
                          </td>
                          <td class="py-1">
                            <v-btn text @click="moveColumnUp(item.text)" class="px-1">
                              <v-icon small color="green">mdi-arrow-up-thick</v-icon>
                            </v-btn>
                            <v-btn text @click="moveColumnDown(item.text)" class="px-1">
                              <v-icon small color="orange">mdi-arrow-down-thick</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </dialog-editor>
                </template>
              </div>
            </v-toolbar>
          </v-col>
          <v-col v-if="!$tools.isDefined(disablePagination)" cols="auto">
            <v-data-footer
                :pagination="pagination"
                :options="options"
                @update:options="updateOptions"
                :itemsPerPageOptions="[100, 500, 1000, 5000]"
                items-per-page-text="$vuetify.dataTable.itemsPerPageText"
                class="ml-0"
            />
          </v-col>
        </v-row>
      </template>
      <template v-slot:item="{ item }">
        <slot name="item" v-bind:item="item" v-bind:items="items" v-bind:headers="headers"/>
      </template>
      <template v-slot:footer.prepend>
        <v-btn small text @click="$tools.download($refs.nTable,name)" :disabled="count===0" class="mr-2" :loading="loading">
          <v-icon small class="pr-2">mdi-download</v-icon>
          Скачать
        </v-btn>
        <v-spacer/>
      </template>
      <template v-if="$tools.isDefined(disablePagination)" v-slot:footer>
        <v-divider/>
        <v-sheet color="transparent" height="46" class="d-flex align-center px-2">
          <v-btn small text @click="$tools.download($refs.nTable,name)" :disabled="count===0" class="mr-2" :loading="loading">
            <v-icon small class="pr-2">mdi-download</v-icon>
            Скачать
          </v-btn>
          <v-spacer/>
          <tooltip>
            <v-chip color="grey lighten-3 mx-1">
              <v-icon class="mr-2" color="red" small>mdi-alert</v-icon>
              <div class="caption black--text">Список ограничен</div>
            </v-chip>
            <template v-slot:content>
              <div>Ограничено до 1000 записей.</div>
              <div>Для получения более точных результатов воспользуйтесь фильтрами</div>
            </template>
          </tooltip>
        </v-sheet>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import Tooltip from "@/componentsV2/base/Tooltip.vue";
import DialogEditor from "@/componentsV2/base/DialogEditor.vue";

export default {
  props: [
    'name',
    'height',
    'headers',
    'selectAll',
    'selectIndeterminate',
    'tableClass',
    'genRequestBuilder',
    'sortBy',
    'groupBy',
    'settingsKey',
    'tableOptions',
    'disablePagination'
  ],
  components: {
    Tooltip,
    DialogEditor
  },
  data: () => ({
    localHeaders: [],
    localHeadersDefault: [],
    options: {},
    items: [],
    count: 0,
    loading: false,
    requestCount: 0,
    responseCount: 0,
    tableSettingsOpen: false,
    key:null,
    //observer: null,
  }),
  watch: {
    options: {
      handler() {
        this.load(true)

        this.$nextTick(() => {
          if (this.tableOptions !== undefined)
            this.$emit('update:tableOptions', this.options)
        });
      },
    },
    tableOptions(v) {
      // при очистке фильтров сбрасываем sort и page
      if (this.tableOptions !== undefined && v === null)
        this.resetSortAndPage()
    },
    groupBy(v) {
      if (v !== undefined)
        this.$nextTick(() => {
          this.collapseAllGroups();
        });
    },
    headers() {
      this.localHeaders = this.headers;
    },
    localHeaders: {
      handler() {
        this.$emit('update:headers', this.localHeaders)
      },
      deep: true,
    },
  },
  computed: {
    visibleHeaders() {
      return this.localHeaders.filter(h => h.visible);
    }
  },
  mounted() {
    this.localHeaders = this.headers;
    this.localHeadersDefault = this.headers

    if (this.settingsKey !== undefined) {//настройки из localStorage
      const tableSettings = localStorage.getItem(this.settingsKey);
      if (localStorage[this.settingsKey] !== undefined && tableSettings !== null)
        this.localHeaders = JSON.parse(tableSettings);
    }

    // если переданы опции
    this.$nextTick(() => {
      if (this.tableOptions !== undefined && this.tableOptions !== null)
        this.options = this.tableOptions
    });
    this.load(true);
  },
  methods: {
    resetSortAndPage() {
      this.options.page = 1
      this.options.sortBy = []
      this.options.sortDesc = []
    },
    clear() {
      this.items = [];
    },
    load(fast = false) {
      this.$tools.throttle(() => {
        this.requestCount++;

        let sorts = [];
        this.options.sortBy.forEach((v, k) => {
          sorts.push({
            field: v,
            isAsc: this.options.sortDesc[k]
          });
        });

        let requestBuilder = null;
        if (this.$tools.isDefined(this.disablePagination)) {
          requestBuilder = this.genRequestBuilder(
              null,
              null,
              sorts
          )
        } else {
          requestBuilder = this.genRequestBuilder(
              this.options.page,
              this.options.itemsPerPage,
              sorts
          )
          //sync options
          this.options.page = requestBuilder._page
          this.options.itemsPerPage = requestBuilder._onPage
        }

        requestBuilder.addStateCallback((v) => {
          if (v.success)
            this.responseCount++

          if (this.responseCount === this.requestCount) {
            this.loading = false
            this.isSuccess = true
            this.requestCount = 0;
            this.responseCount = 0;
          } else {
            this.loading = true
            this.isSuccess = false
          }

          this.isError = v.error;
          this.errorMessage = v.errorMessage;
          // this.loading = v.loading;
          // this.isSuccess = v.success;

          if (this.isSuccess) {
            //this.observerSet();

            v.items.forEach(v=>{
              v._key = v.id;
            });
            this.items = v.items;
            this.count = v.count;

            //return to the first page if items is empty and it isn't first page
            if (v.items.length === 0 && this.options.page > 1)
              this.options.page = 1;

          }
        })


        requestBuilder.request(null, (e) => {
          this.$store.commit('alertError', e);
        })


      }, fast ? 100 : 1000, 'nTableView')
    },
    collapseAllGroups() {
      const table = this.$refs.nTable;
      if (table && table.openCache) {
        Object.keys(table.openCache).forEach((group) => {
          this.$set(table.openCache, group, false);
        });
      }
    },
    moveColumnUp(selectedColumn) {
      const index = this.localHeaders.findIndex(h => h.text === selectedColumn);
      if (index <= 0) return; // Если элемент первый или не найден - выходим

      // функционал выделения строки с которой взаимодействуем
      this.localHeaders.forEach(header => {
        header.isSelected = false;
      });
      this.localHeaders[index].isSelected = true;

      const newHeaders = [...this.localHeaders];
      [newHeaders[index - 1], newHeaders[index]] = [newHeaders[index], newHeaders[index - 1]];
      this.localHeaders = newHeaders;
    },
    moveColumnDown(selectedColumn) {
      const index = this.localHeaders.findIndex(h => h.text === selectedColumn);

      if (index === -1 || index >= this.localHeaders.length - 1) return; // Если элемент последний или не найден

      // функционал выделения строки с которой взаимодействуем
      this.localHeaders.forEach(header => {
        header.isSelected = false;
      });
      this.localHeaders[index].isSelected = true;

      const newHeaders = [...this.localHeaders];
      [newHeaders[index], newHeaders[index + 1]] = [newHeaders[index + 1], newHeaders[index]];
      this.localHeaders = newHeaders;
    },
    saveTableSettings() {
      this.localHeaders.forEach(header => {
        delete header.isSelected;
      }); // очищаем от isSelected
      localStorage.setItem(this.settingsKey, JSON.stringify(this.localHeaders));
    },
    /*
    observerSet() {
      this.$nextTick(() => {
        if (this.observer !== null)
          this.observer.disconnect()

        let els = this.$refs.nTable.$el.querySelectorAll('.v-data-table__wrapper tbody tr');
        if (els.length === 0)
          return;

        this.observer = new IntersectionObserver(entries => {
          entries
              .filter(v => v.isIntersecting)
              .forEach(v => {
                console.log(v.target);
              })
        }, {threshold: 0.1})

        els.forEach(v => this.observer.observe(v))
      });
    },
     */
  }
}
</script>
